<mat-toolbar color="primary">Bridge Diagnostics</mat-toolbar>

<mat-dialog-content class="!flex !p-0 !text-black">
  <div class="flex h-full w-full">
    <nav class="flex w-56 shrink-0 flex-col bg-slate-50">
      <mat-action-list class="!pt-0">
        <button
          mat-list-item
          (click)="selectPage(BridgeDiagnosticsPage.DiagnosticStatus)"
          [ngClass]="{ 'active-page': activePage() === BridgeDiagnosticsPage.DiagnosticStatus }"
        >
          <mat-icon matListItemIcon>monitor_heart</mat-icon>
          <span matListItemTitle>Diagnostic Status</span>
        </button>
        <button
          mat-list-item
          (click)="selectPage(BridgeDiagnosticsPage.ConfigConflicts)"
          [ngClass]="{ 'active-page': activePage() === BridgeDiagnosticsPage.ConfigConflicts }"
        >
          <mat-icon matListItemIcon>warning</mat-icon>
          <span matListItemTitle>Config Conflicts</span>
        </button>
      </mat-action-list>
    </nav>

    <div class="flex-1 overflow-auto border-l border-black border-opacity-10">
      @switch (activePage()) {
        @case (BridgeDiagnosticsPage.DiagnosticStatus) {
          <pt-bridge-diagnostic-status [practice]="data.practice" />
        }
        @case (BridgeDiagnosticsPage.ConfigConflicts) {
          <pt-bridge-config-conflicts [practice]="data.practice" />
        }
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="!border-slate-100">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
